/*
 * @Author: lixin jiang
 * @Date: 2021-07-20 15:45:02
 * @LastEditTime: 2022-06-10 21:32:13
 * @LastEditors: Yu Wang
 * @Description:
 * @FilePath: \kitchen-online-web\src\utils\rules\const.js
 * @
 */
// 橱柜的类型
export const cabinetShape = {
  typeI: 'I',
  typeL: 'L',
  typeU: 'U',
  typeH: 'H',
  typeUs: 'U_S',
};

// 长度
export const lenType = {
  len1: 'len1',
  len2: 'len2',
  len3: 'len3',
};

export const lenName = {
  L1: 'L1',
  L2: 'L2',
  L3: 'L3',
};

// 最小过道宽度
export const minimumAisle = 90;

export const sidePlateWidth = 63.5 * 2;

// 长度最大500
export const maxLen = 500;


// 柜体类型
export const cabinetType1 = {
  I: 1, // 两抽灶下柜
  II: 2, // 水槽空柜
  III: 3, // 普通柜体/底柜
  IV: 4, // 普通柜体/顶柜
  V: 5, // 3抽抽屉柜
  VI: 6, // 2抽抽屉柜
  VII: 7, // 4抽抽屉柜
  VIII: 8, // 转角柜/底柜
  IX: 9, // 转角柜/顶柜
  X: 10, // 高柜/全隔板3开门
  XI: 11, // 高柜/烤箱柜 (一个洞)
  XII: 12, // 高柜/微波炉和烤箱柜(两个洞)
  XIII: 13, // 调料抽
  XIV: 14, // 抽油烟机柜
  XV: 15, // 支腿
  XVI: 16, // 补板/底柜
  XVII: 17, // 补板/顶柜
  XVIII: 18, // 转篮/底柜
  XIX: 19, // 转篮/顶柜
  XX: 20, // 台面
  XXV: 25, // 水龙头
  XXVI: 26, // 水槽
  XXVII: 27, // 水槽转角柜
  XXVIII: 28, // 灶台转角柜
  XXXIII: 33, // 高柜，带清洁用品内配件
  XXXIV: 34, // 搁板高柜框/4屉/1门/2前板
  XXXV: 35, // 高柜，带搁板/2个门
  XXXVI: 36, // 高柜，带清洁用品内配件
  XXXVII: 37, // 搁板高柜框/4屉/1门/2前板
};

export const HighCabinetId = [10, 11, 12, 33, 34, 35, 36, 37]; // 高柜对应的CategoryId集合

// 内配储物 typeCode
export const typeCode = {
  code1: '11147', // 顶柜转篮
  code2: '28029', // 底柜转篮128
  code3: '27916', // 底柜转篮88
};

export const defaultSize = {
  I: {
    bottom: {
      len1: 240,
    },
    top: {
      len1: 240,
    },
  },
  L: {
    bottom: {
      len1: 240,
      len2: 160,
    },
    top: {
      len1: 240,
      len2: 160,
    },
  },
  H: {
    bottom: {
      len1: 240,
      len3: 240,
    },
    top: {
      len1: 240,
      len3: 240,
    },
  },
  U: {
    bottom: {
      len1: 238,
      len2: 228,
      len3: 238,
    },
    top: {
      len1: 238,
      len2: 228,
      len3: 238,
    },
  },
};

export const getPlatform = {
  smp: 'SMP',
  app: 'APP',
  ikeacn: 'WEB',
};
